// Copyright (c) 2022 by Move Closer

import { ShapeRegistry, SizeRegistry, ThemeRegistry, VariantRegistry } from '../../composables'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface BadgeProps {
  /**
   * Determines label of the badge.
   */
  label?: string

  /**
   * Determines the theme of the badge.
   */
  theme: string

  /**
   * Determines the shape of the badge.
   */
  shape: string

  /**
   * Determines the size of the badge.
   */
  size: string

  /**
   * Determines the variant of the badge.
   */
  variant: string
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl> (edited)
 */
export enum BadgeTheme {
  Danger = 'danger',
  Default = 'default',
  Flat = 'flat',
  Premium = 'premium',
  Promo = 'promo',
  Info = 'info',
  Muted = 'muted',
  Success = 'success',
  Primary = 'primary',
  Warning = 'warning'
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl> (edited)
 */
export const badgeThemeClassRegistry: ThemeRegistry<string> = {
  [BadgeTheme.Danger]: '--danger',
  [BadgeTheme.Default]: '',
  [BadgeTheme.Premium]: '--premium',
  [BadgeTheme.Promo]: '--promo',
  [BadgeTheme.Flat]: '--flat',
  [BadgeTheme.Info]: '--info',
  [BadgeTheme.Muted]: '--muted',
  [BadgeTheme.Success]: '--success',
  [BadgeTheme.Primary]: '--primary',
  [BadgeTheme.Warning]: '--warning'
}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export enum BadgeSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const badgeSizeClassRegistry: SizeRegistry<string> = {
  [BadgeSize.Small]: '--small',
  [BadgeSize.Medium]: '',
  [BadgeSize.Large]: '--large'
}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export enum BadgeShape {
  Rectangle = 'rectangle',
  Square = 'square'
}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const badgeShapeClassRegistry: ShapeRegistry<string> = {
  [BadgeShape.Rectangle]: '',
  [BadgeShape.Square]: '--square'
}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl> (edited)
 */
export enum BadgeVariant {
  Full = 'full',
  Outline = 'outline',
}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const badgeVariantClassRegistry: VariantRegistry<string> = {
  [BadgeVariant.Full]: '',
  [BadgeVariant.Outline]: '--outline'
}
